export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const GAME_TOKEN_ID = process.env.REACT_APP_GAME_TOKEN_ID;
